var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.02618 5.28026V0.435547H15.4858V5.28026H9.02618ZM0.95166 8.51007V0.435547H7.41128V8.51007H0.95166ZM9.02618 14.9697V6.89516H15.4858V14.9697H9.02618ZM0.95166 14.9697V10.125H7.41128V14.9697H0.95166ZM2.56656 6.89516H5.79637V2.05045H2.56656V6.89516ZM10.6411 13.3548H13.8709V8.51007H10.6411V13.3548ZM10.6411 3.66535H13.8709V2.05045H10.6411V3.66535ZM2.56656 13.3548H5.79637V11.7399H2.56656V13.3548Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardBlack);
export default __webpack_public_path__ + "static/media/dashboard-black.b41dd3c0f6aab261952ec34da883037a.svg";
export { ForwardRef as ReactComponent };